<template>
  <div>
    <el-upload ref="upload"
               action=""
               class="avatar-uploader"
               :class="{ 'plus-hidden': fileList.length >= limit || status !== 'edit' }"
               :accept="accept"
               :show-file-list="false"
               :file-list="fileList"
               :http-request="handleChange">
      <i class="el-icon-plus avatar-uploader-icon"
         :style="plusStyle"></i>
    </el-upload>
    <ul style="display: inline-block;line-height: 0;"
        class="el-upload-list el-upload-list--picture-card">
      <li tabindex="0"
          :style="plusStyle"
          v-for="(item, index) in fileList"
          :key="index"
          class="el-upload-list__item is-success">
        <video class="el-upload-list__item-thumbnail"
               v-if="item.type === 'video'">
          <source :src="item.url">
          您的浏览器不支持Video标签。
        </video>
        <img :src="item.url"
             v-else
             class="el-upload-list__item-thumbnail">
        <span class="el-upload-list__item-actions">
          <span class="el-upload-list__item-preview">
            <i class="el-icon-zoom-in"
               @click="handlePictureCardPreview(item)"></i>
          </span>
          <span class="el-upload-list__item-delete"
                v-if="status === 'edit'">
            <i class="el-icon-delete"
               @click="handleRemove(index)"></i>
          </span>
        </span>
      </li>
    </ul>
    <div v-if="status === 'edit'"
         class="el-upload__tip"
         style="margin-top:0">只能上传{{accept}}文件，最多{{limit}}张<b v-if="acceptInfo.hasImage">，图片不超过2M</b><b v-if="acceptInfo.hasVideo">，视频不超过10M</b>。</div>
    <cropper-modal v-if="cropper"
                   :visible="visible"
                   :img="img"
                   :loading="loading"
                   @crop:cancel='cropCancel'
                   @crop:submit="cropSubmit"
                   :fixedNumber="fixedNumber"
                   :autoCropWidth="autoCropWidth"
                   :autoCropHeight="autoCropHeight"></cropper-modal>
    <el-dialog :visible.sync="previewVisible"
               width="600px"
               append-to-body>
      <video width="100%"
             v-if="previewUrl.type === 'video'" controls>
        <source :src="previewUrl.url">
        您的浏览器不支持Video标签。
      </video>
      <img width="100%"
           v-else
           :src="previewUrl.url">
    </el-dialog>
  </div>
</template>

<script>
import CropperModal from './cropper-modal.vue'
export default {
  name: 'upload-image-new',
  components: { CropperModal },
  props: {
    value: {
      type: Array,
      required: true,
      default () {
        return []
      }
    },
    accept: {
      type: String,
      default: 'image/*'
    },
    limit: {
      type: Number,
      default: 1
    },
    status: {
      type: String,
      default: 'edit'
    },
    cropper: {
      type: Boolean,
      default: false
    },
    fixedNumber: {
      type: Array,
      default () {
        return [1, 1]
      }
    },
    autoCropWidth: {
      type: Number,
      default: 200
    },
    autoCropHeight: {
      type: Number,
      default: 200
    }
  },
  data () {
    return {
      loading: false,
      previewVisible: false,
      previewUrl: {},
      visible: false,
      img: null
    }
  },
  computed: {
    plusStyle () {
      return { width: (this.autoCropWidth / 2) + 'px', height: (this.autoCropHeight / 2) + 'px', lineHeight: (this.autoCropHeight / 2) + 'px' }
    },
    acceptInfo () {
      return {
        hasImage: this.accept.indexOf('image') > -1,
        hasVideo: /(.mp4|.webm|.ogg)/.test(this.accept)
      }
    },
    fileList: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    cropCancel () {
      this.visible = false
      // this.$refs.upload.clearFiles()
    },
    cropSubmit (file) {
      this.uploadFile(file.file)
    },
    handleChange ({ file }) {
      console.log('http-request', file)
      let type = file.type
      if (type.indexOf('image') > -1) {
        const isLt2M = file.size / 1024 / 1024 > 2
        if (isLt2M) {
          this.$message.error('上传图片大小不能超过 2MB!')
          return
        }
      }
      if (type.indexOf('video') > -1) {
        const isLt10M = file.size / 1024 / 1024 > 10
        if (isLt10M) {
          this.$message.error('上传视频大小不能超过 2MB!')
          return
        }
      }
      if (this.cropper) {
        let img = new Image()
        img.src = URL.createObjectURL(file)
        img.onload = () => {
          let ratio = this.fixedNumber[0] / this.fixedNumber[1]
          if (img.width / img.height !== ratio) {
            this.$message.error(`图片推荐宽高比例为${this.fixedNumber[0]}:${this.fixedNumber[1]}`)
            this.visible = true
            this.img = URL.createObjectURL(file)
          } else {
            this.uploadFile(file)
          }
        }
      } else {
        this.uploadFile(file)
      }
    },
    uploadFile (file) {
      this.loading = true
      let form = new FormData()
      form.append('file', file)
      this.$store.dispatch('common/uploadfile', {
        payload: form,
        success: (res) => {
          this.fileList.push({
            url: res.data.viewUrl + res.data.filepath,
            filepath: res.data.filepath,
            name: file.name,
            type: file.type.indexOf('image') > -1 ? 'image' : 'video'
          })
          this.$refs.upload.clearFiles()
          this.cropCancel()
          this.loading = false
        },
        fail: () => {
          this.loading = false
          this.$refs.upload.clearFiles()
        }
      })
    },
    handleRemove (index) {
      this.fileList.splice(index, 1)
    },
    handlePictureCardPreview (item) {
      this.previewUrl = item
      this.previewVisible = true
    }
  }
}
</script>
<style lang="stylus">
.plus-hidden {
  .el-upload {
    display: none;
  }
}

.avatar-uploader {
  display: inline-block;
  vertical-align: top;
  margin: 0 8px 8px 0;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  text-align: center;
}
</style>
